import { Route, Routes } from 'react-router-dom';
import GuardedRoute from './GuardedRoute';
import routeConfig from './routeConfig';

const Router = () => (
  <Routes>
    {routeConfig.map(r => (
      <Route
        path={r.path}
        element={<GuardedRoute component={r.component} guards={r.guards} />}
        key={r.path}
      />
    ))}
  </Routes>
);

export default Router;
